import Button, { buttonClasses } from "@bmi-digital/components/button";
import { styled } from "@mui/material/styles";

export const BackToResultsElement = styled("div")(() => ({
  display: "flex"
}));

export const BackToResultsSeparator = styled("div")(() => ({
  marginLeft: "8px",
  marginRight: "8px",
  width: "1px",
  justifySelf: "stretch",
  backgroundColor: "#cccccc"
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${buttonClasses.textDarkBg}`]: {
    textDecoration: "underline",
    textDecorationColor: theme.colours.storm,
    textDecorationSkipInk: "none"
  }
}));
